import { render, staticRenderFns } from "./ProductAside.vue?vue&type=template&id=95ac511c&"
import script from "./ProductAside.vue?vue&type=script&lang=js&"
export * from "./ProductAside.vue?vue&type=script&lang=js&"
import style0 from "./ProductAside.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports